<script>
const elTransition =
  '0.3s height ease-in-out, 0.3s padding-top ease-in-out, 0.3s padding-bottom ease-in-out'
const Transition = {
  'before-enter'(element) {
    element.style.transition = elTransition
    if (!element.oldData) {
      element.oldData = {}
    }

    element.oldData.paddingTop = element.style.paddingTop
    element.oldData.paddingBottom = element.style.paddingBottom

    element.style.height = 0
    element.style.paddingTop = 0
    element.style.paddingBottom = 0
  },

  enter(element) {
    element.oldData.overflow = element.style.overflow
    if (element.scrollHeight !== 0) {
      element.style.height = element.scrollHeight + 'px'
      element.style.paddingTop = element.oldData.paddingTop
      element.style.paddingBottom = element.oldData.paddingBottom
    } else {
      element.style.height = ''
      element.style.paddingTop = element.oldData.paddingTop
      element.style.paddingBottom = element.oldData.paddingBottom
    }

    element.style.overflow = 'hidden'
  },

  'after-enter'(element) {
    element.style.transition = ''
    element.style.height = 'auto'
    element.style.overflow = element.oldData.overflow
  },

  'before-leave'(element) {
    if (!element.oldData) {
      element.oldData = {}
    }
    element.oldData.paddingTop = element.style.paddingTop
    element.oldData.paddingBottom = element.style.paddingBottom
    element.oldData.overflow = element.style.overflow

    element.style.height = element.scrollHeight + 'px'
    element.style.overflow = 'hidden'
  },

  leave(element) {
    if (element.scrollHeight !== 0) {
      element.style.transition = elTransition
      element.style.height = 0
      element.style.paddingTop = 0
      element.style.paddingBottom = 0
    }
  },

  'after-leave'(element) {
    element.style.transition = ''
    element.style.height = 'auto'
    element.style.overflow = element.oldData.overflow
    element.style.paddingTop = element.oldData.paddingTop
    element.style.paddingBottom = element.oldData.paddingBottom
  }
}

export default {
  name: 'GjwCollapse',
  functional: true,
  render(createElement, { children }) {
    const data = {
      on: Transition
    }
    return createElement('transition', data, children)
  }
}
</script>
